import { INIT, SUCCESS, LOADING, ERROR } from "../../../utils/constants";
import {
  GET_AZURE_DASHBOARD_DETAILS,
  GET_AZURE_DASHBOARD_DETAILS_SUCCESS,
  GET_AZURE_DASHBOARD_DETAILS_ERROR,
  GET_LOCATION_FORECAST_BILL_AZURE,
  GET_FORECAST_BILL_AZURE_SUCCESS,
  GET_FORECAST_BILL_AZURE_ERROR,
  GET_DAILY_FORECAST_BILL_AZURE,
  GET_DAILY_FORECAST_BILL_AZURE_SUCCESS,
  GET_DAILY_FORECAST_BILL_AZURE_ERROR,
  GET_AZURE_DASHBOARD_SERVICES_DETAILS,
  GET_AZURE_DASHBOARD_SERVICES_DETAILS_SUCCESS,
  GET_AZURE_DASHBOARD_SERVICES_DETAILS_ERROR,
  GET_RESOURCE_GROUP_NAME,
  GET_RESOURCE_GROUP_NAME_SUCCESS,
  GET_RESOURCE_GROUP_NAME_ERROR,
} from "./constant";

const initialState = {
  phase: INIT,
  azureMetricsLogsList: null,
  error: null,
};

const initialResourceGroupdNameState = {
  phase10: INIT,
  resourceGroupNameList: null,
  error: null,
};

const initialBillingState = {
  phase1: INIT,
  azureForecastBillList: null,
  error: null,
};

const initialDailyState = {
  phase2: INIT,
  azureDailyForecastBillList: null,
  error: null,
};

const initialServicesListState = {
  phase3: INIT,
  azureDashboardServicesDetailsList: null,
  error: null,
};

/**
 * User Reducer
 * @param {Object} state
 * @param {Object} action
 */

export function ResourceGroupNameStore(
  state = initialResourceGroupdNameState,
  action
) {
  switch (action.type) {
    case GET_RESOURCE_GROUP_NAME:
      return {
        ...state,
        phase10: LOADING,
      };
    case GET_RESOURCE_GROUP_NAME_SUCCESS:
      return {
        ...state,
        phase10: SUCCESS,
        resourceGroupNameList: action.data,
        error: null,
      };
    case GET_RESOURCE_GROUP_NAME_ERROR:
      return { ...state, phase10: ERROR, error: action.error };

    default:
      return state;
  }
}

export function AzureDashboardServicesDetailsStore(
  state = initialServicesListState,
  action
) {
  switch (action.type) {
    case GET_AZURE_DASHBOARD_SERVICES_DETAILS:
      return {
        ...state,
        phase3: LOADING,
      };
    case GET_AZURE_DASHBOARD_SERVICES_DETAILS_SUCCESS:
      return {
        ...state,
        phase3: SUCCESS,
        azureDashboardServicesDetailsList: action.data,
        error: null,
      };
    case GET_AZURE_DASHBOARD_SERVICES_DETAILS_ERROR:
      return { ...state, phase3: ERROR, error: action.error };

    default:
      return state;
  }
}

export function AzureForecastBillStore(state = initialBillingState, action) {
  switch (action.type) {
    case GET_LOCATION_FORECAST_BILL_AZURE:
      return {
        ...state,
        phase1: LOADING,
      };
    case GET_FORECAST_BILL_AZURE_SUCCESS:
      return {
        ...state,
        phase1: SUCCESS,
        azureForecastBillList: action.data,
        error: null,
      };
    case GET_FORECAST_BILL_AZURE_ERROR:
      return { ...state, phase1: ERROR, error: action.error };

    default:
      return state;
  }
}

export function AzureDailyForecastBillStore(state = initialDailyState, action) {
  switch (action.type) {
    case GET_DAILY_FORECAST_BILL_AZURE:
      return {
        ...state,
        phase2: LOADING,
      };
    case GET_DAILY_FORECAST_BILL_AZURE_SUCCESS:
      return {
        ...state,
        phase2: SUCCESS,
        azureDailyForecastBillList: action.data,
        error: null,
      };
    case GET_DAILY_FORECAST_BILL_AZURE_ERROR:
      return { ...state, phase2: ERROR, error: action.error };

    default:
      return state;
  }
}

export function AzureDashboardDetailsStore(state = initialState, action) {
  switch (action.type) {
    case GET_AZURE_DASHBOARD_DETAILS:
      return {
        ...state,
        phase: LOADING,
      };
    case GET_AZURE_DASHBOARD_DETAILS_SUCCESS:
      return {
        ...state,
        phase: SUCCESS,
        azureDashboardDetailsList: action.data,
        error: null,
      };
    case GET_AZURE_DASHBOARD_DETAILS_ERROR:
      return { ...state, phase: ERROR, error: action.error };

    default:
      return state;
  }
}
